<div id="reset-password">
    <div class="reset-password-content">
        <div class="row">
            <div class="head_container d-flex justify-content-center align-items-center">
                <label>{{'reset_password' | translate }}</label>
            </div>
        </div>
        <div class="row px-2" id="change_password">
            <div class="w-100 mb-5">
                <ng-container *ngIf="!isSubmited">
                    <form id="passwordForm" [formGroup]="resetForm" (ngSubmit)="onResetPassword()">
                        <div class="form-group grp">
                            <label for="password1"><strong>{{'new_password' | translate}}</strong></label>
                            <div class="d-flex align-items-center">
                                <input mat-input [type]="hideNewPassword ? 'password' : 'text'" class="form-control" name="password1" id="password1" formControlName="newPassword" placeholder="*********" autocomplete="off">
                                <mat-icon matSuffix class="icon-hide-position" (click)="hideNewPassword = !hideNewPassword">{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </div>
                        </div>
                        <div class="form-group grp">
                            <label for="password2"><strong>{{'confirm_password' | translate }}</strong></label>
                            <div class="d-flex align-items-center">
                                <input mat-input [type]="hideConfirmPassword ? 'password' : 'text'" class="form-control" name="password2" id="password2" formControlName="validationPassword" placeholder="*********" autocomplete="off">
                                <mat-icon matSuffix class="icon-hide-position" (click)="hideConfirmPassword = !hideConfirmPassword">{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </div>
                            <label class="text-danger" *ngIf="resetForm.value.validationPassword != '' && resetForm.controls['validationPassword'].hasError('NoPassswordMatch')">
                              {{'password_not_match' | translate }} 
                            </label>
                        </div>
                        <div class="row grp">
                            <div class="col-sm">
                                <p>{{'password_must_contain' | translate }}</p>
                                <div class="row">
                                    <div class="col-sm">

                                        <label class="col d-flex align-items-center" [ngClass]="resetForm.controls['newPassword'].hasError('required') || resetForm.controls['newPassword'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                                          <i class="material-icons">{{ resetForm.controls['newPassword'].hasError('required') ||
                                            resetForm.controls['newPassword'].hasError('minlength') ? 'close' :
                                            'check' }}</i>
                                          {{'atleast_8_characters' | translate }}
                                        </label>
                                        <label class="col d-flex align-items-center" [ngClass]="resetForm.controls['newPassword'].hasError('required') || resetForm.controls['newPassword'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                                          <i class="material-icons">{{ resetForm.controls['newPassword'].hasError('required') ||
                                            resetForm.controls['newPassword'].hasError('hasNumber') ? 'close' :
                                            'check' }}</i>
                                          {{'atleast_1_number' | translate }}
                                        </label>
                                        <label class="col d-flex align-items-center" [ngClass]="resetForm.controls['newPassword'].hasError('required') || resetForm.controls['newPassword'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                                          <i class="material-icons">{{ resetForm.controls['newPassword'].hasError('required') ||
                                            resetForm.controls['newPassword'].hasError('hasCapitalCase') ? 'close' :
                                            'check' }}</i>
                                         {{'atleast_1_capital_case' | translate }} 
                                        </label>
                                        <label class="col d-flex align-items-center" [ngClass]="resetForm.controls['newPassword'].hasError('required') || resetForm.controls['newPassword'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                                          <i class="material-icons">{{ resetForm.controls['newPassword'].hasError('required') ||
                                            resetForm.controls['newPassword'].hasError('hasSmallCase') ? 'close' :
                                            'check' }}</i>
                                         {{'atleast_1_small_case' | translate }} 
                                        </label>
                                        <label class="col d-flex align-items-center" [ngClass]="resetForm.controls['newPassword'].hasError('required') || resetForm.controls['newPassword'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                                          <i class="material-icons">
                                            {{ resetForm.controls['newPassword'].hasError('required') || resetForm.controls['newPassword'].hasError('hasSpecialCharacters') ? 'close' : 'check' }}</i>
                                          {{'atleast_1_special_characters' | translate }}
                                        </label>
                                        <!-- <label class="col d-flex align-items-center" [ngClass]="resetForm.controls['newPassword'].hasError('required') || resetForm.controls['newPassword'].hasError('hasSpace') ? 'text-danger' : 'text-success'">
                                          <i class="material-icons">
                                            {{ resetForm.controls['newPassword'].hasError('required') || resetForm.controls['newPassword'].hasError('hasSpace') ? 'close' : 'check' }}</i>
                                          Has Space!
                                        </label> -->
                                        <div class="row">
                                            <div class="col-sm">
                                                Note: Spaces are not allowed
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <button type="submit" class="col-sm btn btn-primary btn-load btn-lg btn-reset" [disabled]="loading">
                          <span *ngIf="!loading">Reset Password</span>
                          <div class="spinner-border text-light" role="status" *ngIf="loading">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </button>
                    </form>
                </ng-container>
                <ng-container *ngIf="isSubmited">
                    <div class="text-center my-5">
                        <h3>{{successMessage}}</h3>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
